import(/* webpackMode: "eager", webpackExports: ["WarrantySupportPage"] */ "/home/ec2-user/ennix-electronics/src/app/warranty-support/_components/WarrantySupportPage.jsx");
